












































































































































































































































































































































import {Component, Prop, Vue} from 'vue-property-decorator';
import JdiContent from "@/components/JdiContent.vue"
import JdiPreview from "@/components/JdiPreview.vue"
import JdiDocs from "@/components/JdiDocs.vue"
import JdsTable from "@/design-system/patterns/Table/JdsTable.vue"
import JdsTableRow from "@/design-system/patterns/Table/JdsTableRow.vue"
import JdsTableCell from "@/design-system/patterns/Table/JdsTableCell.vue"
import JdsButton from "@/design-system/components/Button/JdsButton.vue"
import JdsTableHeading from "@/design-system/patterns/Table/JdsTableHeading.vue"
import JdsTableToolbarCell from "@/design-system/patterns/Table/JdsTableToolbarCell.vue"
import JdsTableCurrencyCell from "@/design-system/patterns/Table/JdsTableCurrencyCell.vue"
import JdsTableBadge from "@/design-system/patterns/Table/JdsTableBadge.vue"
import JdsLocaleProvider from "@/design-system/foundation/JdsLocaleProvider.vue"
// import JdsSelectField from "@/design-system/components/Fields/JdsSelectField.vue"
// import JdsSelectFieldOption from "@/design-system/components/Fields/JdsSelectFieldOption.vue"
import JdsTableFooterCutout from "@/design-system/patterns/Table/JdsTableFooterCutout.vue"
import JdsTableCurrencyFooter from "@/design-system/patterns/Table/JdsTableCurrencyFooter.vue"
import JdsTableFooterRow from "@/design-system/patterns/Table/JdsTableFooterRow.vue"
import JdsPaginator from "@/design-system/components/Paginator/JdsPaginator.vue"
import JdsMoney from "@/design-system/components/Money/JdsMoney.vue"
import JdsIcon from "@/design-system/icons/JdsIcon.vue"
import JdsGlyph from "@/design-system/icons/JdsGlyph.vue"
import JdiDirective from "@/components/JdiDirective.vue"
import JdsTableSegment from "@/design-system/patterns/Table/JdsTableSegment.vue"

@Component({
    components: {
        JdsTableSegment,
        JdiDirective,
        JdsGlyph,
        JdsIcon,
        JdsMoney,
        JdsPaginator,
        JdsTableFooterRow,
        JdsTableCurrencyFooter,
        JdsTableFooterCutout,
        // JdsSelectFieldOption,
        // JdsSelectField,
        JdsLocaleProvider,
        JdsTableBadge,
        JdsTableCurrencyCell,
        JdsTableToolbarCell,
        JdsTableHeading, JdsButton, JdsTableCell, JdsTableRow, JdsTable, JdiDocs, JdiPreview, JdiContent
    }
})
export default class Table extends Vue {
    locale = 'en-gb';
}
